// Module de lecture vidéo HLS
import React from 'react';
import { HLSVideoPlayer } from '../../G&CSCM/Core/HLSVideoPlayer';

interface VideoModuleProps {
    fileId?: string;
    src?: string;
    poster?: string;
    autoPlay?: boolean;
    controls?: boolean;
}

const VideoModule: React.FC<VideoModuleProps> = ({
    fileId,
    src,
    poster,
    autoPlay = false,
    controls = true
}) => {
    return (
        <div className="video-module" style={{ width: '100%', height: '100%' }}>
            <HLSVideoPlayer
                fileId={fileId}
                src={src}
                poster={poster}
                autoPlay={autoPlay}
                controls={controls}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default VideoModule;


